import { toggleModal } from "@/components/ModalComponent.vue";
import { EventBusNames } from "@/utils/EventBus";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { defineComponent } from "vue";
import RatingItem from "./RatingItem.vue";
import IRating from "@/interfaces/IRating";
import { syncSessionUseCase } from "@/useCases";

export default defineComponent({
  mounted() {
    this.loading = true;
    this.getItems();
  },
  data() {
    return {
      loading: false,
      submitting: false,
      ratings: [] as IRating[],
      v$: useVuelidate(),
      form: {
        reason_report: "",
      },
      currentRating: null as IRating | null,
    };
  },
  validations() {
    return {
      form: {
        reason_report: {
          required: helpers.withMessage(
            "Informe por qual motivo deseja reportar",
            required
          ),
        },
      },
    };
  },
  methods: {
    async getItems() {
      try {
        const res = await this.$appointmentService.callRatings();
        this.ratings = res.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleReport(rating: any) {
      this.currentRating = rating;
      toggleModal("report_rating_modal");
    },
    async handleConfirmReport() {
      try {
        this.submitting = true;

        const params = {
          appointment_id: this.currentRating?.appointment?.id,
          called_rating_id: this.currentRating?.id,
          reason_report: this.form.reason_report,
        };

        await this.$appointmentService.reviewCallRatings(params);

        this.$eventBus.$emit(EventBusNames.SHOW_TOAST, {
          title: "Avaliação em análise",
          msg: "Nosso time irá analisar o conteúdo da sua avaliação.",
        });

        await this.getItems();

        this.resetForm();
      } catch (error) {
        console.log("ERRO NO HANDLE CONFIRM REMOVE DA RATINGS SCREEN", error);
      } finally {
        this.submitting = false;
      }
    },
    resetForm() {
      this.v$.form.$reset();
      this.form.reason_report = "";
      toggleModal("report_rating_modal");
    },
    async onRemove(id: number) {
      this.$eventBus.$emit(EventBusNames.SHOW_CONFIRMATION_ALERT, {
        title: "Deseja remover este depoimento?",
        message:
          "Uma vez que um depoimento for removido, não será possível recupera-lo.",
        confirmationButtonLabel: "Sim, remover",
        cancellationButtonLabel: "Não, voltar",
        confirmCallback: () => this.handleRemove(id),
      });
    },
    async handleRemove(id: number) {
      try {
        await this.$appointmentService.removeCallRating(id);
        this.$eventBus.$emit(EventBusNames.SHOW_TOAST, {
          title: "Depoimento removido",
          msg: "O depoimento foi removido e não está mais visível.",
        });
        this.getItems();
        await syncSessionUseCase.execute();
      } catch (error) {
        console.error(error);
      }
    },
    async handleChange(rating: IRating, index: number) {
      try {
        this.ratings[index].submitting = true;
        await this.$appointmentService.updateCallRating(rating.id, {
          active: !rating.active,
        });
        await this.getItems();
        await syncSessionUseCase.execute();
      } catch (error) {
        console.error(error);
      } finally {
        this.ratings[index].submitting = false;
      }
    },
  },
  components: {
    RatingItem,
  },
});
